import { motion } from "framer-motion";

interface AurelianAvatarProps {
  isTyping?: boolean;
  size?: "sm" | "md" | "lg";
}

const sizes = { sm: "w-8 h-8", md: "w-10 h-10", lg: "w-12 h-12" };
const imgSizes = { sm: "w-5 h-5", md: "w-6 h-6", lg: "w-8 h-8" };

export function AurelianAvatar({ isTyping = false, size = "md" }: AurelianAvatarProps) {
  return (
    <motion.div
      className={`${sizes[size]} rounded-full bg-gradient-to-br from-amber-50 to-amber-100 border-2 border-amber-300/50 flex items-center justify-center shadow-lg shadow-amber-200/30 relative overflow-hidden flex-shrink-0`}
      animate={isTyping ? { scale: [1, 1.05, 1] } : {}}
      transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
    >
      <motion.div
        className="absolute inset-0 bg-gradient-to-br from-amber-300/20 to-transparent rounded-full"
        animate={{ opacity: [0.3, 0.6, 0.3] }}
        transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
      />
      <img
        src="/images/avatar_chatbot_hd.png"
        srcSet="/images/avatar_chatbot_hd.png 1x, /images/avatar_chatbot_hd_2x.png 2x"
        alt="Aurelian"
        className={`${imgSizes[size]} relative z-10 object-contain`}
      />
      {isTyping && (
        <motion.div
          className="absolute inset-0 rounded-full border-2 border-amber-400/50"
          animate={{ scale: [1, 1.3], opacity: [0.5, 0] }}
          transition={{ repeat: Infinity, duration: 1.2, ease: "easeOut" }}
        />
      )}
    </motion.div>
  );
}
